import { Component, OnInit } from "@angular/core";
import { AuthService } from "@core/auth.service";
import { NavParams, ModalController, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { HeaderComponent } from "../../../components/header/header.component";
import { NgClass } from "@angular/common";

@Component({
    selector: "app-syndicate-leave-final",
    templateUrl: "./syndicate-leave-final.component.html",
    styleUrls: ["./syndicate-leave-final.component.scss"],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        NgClass,
        TranslatePipe,
    ],
})
export class SyndicateLeaveFinalComponent implements OnInit {
  pageTitle = "Leave syndicate";
  syndicate: any;
  count = 0;
  isChecked = false;
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  constructor(private navParams: NavParams, private modalCtrl: ModalController,
    public translate: TranslateService,
    private GTMSegment: GTMSegmentService,
    private authService: AuthService,
  ) {
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService.getConstantsMsg$.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    })

    this.GTMSegment.GTMPopupInitialization("LeaveSyndicateFinal");
  }

  ngOnInit() {
    this.syndicate = this.navParams?.data?.syndicateData;
    this.translate.get(['syndicate-leave-final.pageTitle']).subscribe((res: string) => {
      this.pageTitle = (res["syndicate-leave-final.pageTitle"])
    }, err => { return (err) })
  }

  onCheck(event: any) {
    if (!event || !event?.detail) return
    this.isChecked = event?.detail?.checked;
  }

  leaveFinal() {
    this.count++;
    if (this.isChecked) {
      this.modalCtrl.dismiss({ leaveFinal: true }).catch(err => { return err });
    } else {
      /*  const msg = this.translatedToastMsg?.["1087"]?.[this.selectedLanguage];
       this.authService.showToast(msg ? msg : "Please accept above terms.", "Info", ""); */
      this.authService.getConstantsMsg("1087").then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "Please accept above terms.",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "error",
          },
        }
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      }).catch((error) => {
        return error;
      });
    }
  }

  backToLeaveSyndicate() {
    this.modalCtrl.dismiss().catch(err => { return err });
  }
}
